import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class ApplicationStateApiService extends ApiService
{

    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService,
                protected localCacheManager: LocalCacheManager)
    {
        super(http, localCacheManager);
    }

    healthCheck(): Observable<any>
    {
        return this.apiRequest(this.apiUrlService.baseHealthCheckApiUrl, this.HttpMethod.Get);
    }
}
